<template>
    <teleport to="body">
        <button
            class="fixed top-32 md:top-36 right-4 z-[9999] px-3 py-2 rounded-full text-white border border-[#0056CC] bg-[#006CFF] shadow-[0_8px_20px_rgba(0,108,255,0.35)]"
            :aria-label="soundMuted ? 'Ton einschalten' : 'Ton ausschalten'"
            @click="$emit('toggle')"
        >
            <div class="wave-arch relative w-[42px] h-[22px] overflow-hidden">
                <span
                    v-for="(h, i) in waveHeights"
                    :key="i"
                    class="bar absolute bottom-0 w-[3px] bg-current rounded-[2px]"
                    :class="{ 'is-playing': soundPlaying && !soundMuted, 'opacity-30': soundMuted }"
                    :style="{ left: `${i * 4}px`, height: `${Math.max(h - 4, 8)}px`, animationDelay: `${i * 80}ms` }"
                />
            </div>
        </button>
    </teleport>
</template>

<script setup>
defineProps({
    soundMuted: { type: Boolean, required: true },
    soundPlaying: { type: Boolean, required: true },
    waveHeights: { type: Array, required: true }
});

defineEmits(['toggle']);
</script>

<style scoped>
.wave-arch .bar {
    transform-origin: 50% 100%;
    animation: none;
}

.wave-arch .bar.is-playing {
    animation: wavePlay 900ms ease-in-out infinite;
}

@keyframes wavePlay {
    0% {
        transform: scaleY(0.35);
    }
    40% {
        transform: scaleY(1.15);
    }
    60% {
        transform: scaleY(0.8);
    }
    100% {
        transform: scaleY(0.35);
    }
}
</style>
